export default "__VITE_ASSET__BYhNHQZd__"